import mutations from "./dashboard-mutations";
import actions from "./dashboard-actions";
import getters from "./dashboard-getters";
import state from "./dashboard-state";
const DashboardStore = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};
export default DashboardStore;